import { bindActionCreators } from '@reduxjs/toolkit';
import { space } from 'folio-common-components';
import * as React from 'react';
import { connect } from 'react-redux';
import { Labels } from '../../messages';
import type { Dispatch, RootState } from '../../state';
import {
  type Owner,
  type Person,
  type PersonFounder,
  thunks as editThunks,
  newPerson,
  selectors,
} from '../../state/editor';
import { isValidPnum } from '../../utils/validators';
import { type InputItem, PersonInput } from '../PersonInput';
import { Box } from '../box';
import { Button, TextButton } from '../buttons';

interface Props {
  initialPerson?: Person;
  onDone: () => any;
  onSavePersonOwner: (p: PersonFounder) => any;
  owners: Owner[];
  editType: 'edit' | 'new';
}

interface State {
  person: Person;
  hasClickedSave: boolean;
}

class BaseOwnerPersonForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      person: props.initialPerson || newPerson(),
      hasClickedSave: false,
    };
  }

  onDone = () => {
    this.props.onDone();
  };

  onSave = () => {
    this.props.onSavePersonOwner(this.state.person);
    this.props.onDone();
  };

  onChange = (p: Person) => {
    this.setState({ person: { ...this.state.person, ...p } });
  };

  getInputs(): InputItem[] {
    if (this.props.initialPerson === undefined) {
      return ['autoName', 'pNum', 'cadasterAddress', 'email', 'phone'];
    } else {
      return ['name', 'pNum', 'cadasterAddress', 'email', 'phone'];
    }
  }

  render() {
    const { person, hasClickedSave } = this.state;
    const { owners, editType } = this.props;
    const autoSuggestBlacklist = owners.map(owner => owner.item.id);

    return (
      <Box>
        <PersonInput
          inputs={this.getInputs()}
          person={person}
          onChange={this.onChange}
          disableAutocomplete={true}
          autoSuggestBlacklist={autoSuggestBlacklist}
          validate={hasClickedSave}
          editType={editType}
        />
        <div css={space([48], 'margin-top')}>
          <Button
            css={space([24], 'margin-right')}
            onClick={() => {
              this.setState({ hasClickedSave: true });
              if (!isValidPnum(person.pNum)) {
                return;
              }
              this.onSave();
            }}
          >
            <Labels.Save />
          </Button>{' '}
          <TextButton onClick={this.onDone}>
            <Labels.Cancel />
          </TextButton>
        </div>
      </Box>
    );
  }
}

function mapStateToProps(state: RootState) {
  return { owners: selectors.owners(state.editor) };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      onSavePersonOwner: editThunks.addPersonFounder,
    },
    dispatch,
  );
}

export const OwnerPersonForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseOwnerPersonForm);
